// DetailsImg.jsx
import React from "react";
import { Card, CardMedia, CardContent, Grid } from "@material-ui/core";
import useStyles from "../Product/styles";

const DetailsImg = ({ primaryImageUrl, secondaryImageUrl }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} justifyContent="space-between">
      {/* Main Image */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardMedia component="img" image={primaryImageUrl} alt="Product Image" className={classes.productImage} />
        </Card>
      </Grid>

      {/* Secondary Images */}
      <Grid container spacing={2} justifyContent="space-between" className={classes.imageGallery}>
        <Grid item xs={6}>
          <Card>
            <CardMedia component="img" image={primaryImageUrl} alt="Product Image" className={classes.productImage} />
            <CardContent></CardContent>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card>
            <CardMedia component="img" image={secondaryImageUrl} alt="Product Image" className={classes.productImage} />
            <CardContent></CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DetailsImg;
